<template>
  <agile :dots="false" :navButtons="false" :autoplay="false" :autoplay-speed="5000" :speed="1000">

<!--    <div class="slide"><img src="img/cafecanna-pie.jpg" alt="Beef and blue murder pie" /></div>-->
    <div class="slide"><img src="img/sandwich.jpg" alt="Langoustine" /></div>

<!--    <div class="slide"><img src="img/cafecanna-ramen.jpg" alt="Foraged kelp miso ramen" /></div>-->
<!--    <div class="slide"><img src="img/cafecanna-crab-ravioli.jpg" alt="Crab and homemade crowdie ravioli" /></div>-->
<!--    <div class="slide"><img src="img/kelp-salad.jpg" alt="Kelp Salad" /></div>-->

  </agile>
</template>

<script>
  export default {
    name: "App",

  };
</script>


